import { render, staticRenderFns } from "./ExtendedTextArea.vue?vue&type=template&id=29a681bc&"
import script from "./ExtendedTextArea.vue?vue&type=script&lang=js&"
export * from "./ExtendedTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports